export class Profitability {
  constructor(props = {}) {
    this.profitability = props.profitability;
    this.max_profitability = props.max_profitability;
    this.min_profitability = props.min_profitability;
    this.units = props.units || '';
    this.valid = props.valid || false;
  }

  isErrored() {
    return this.profitability === null || this.profitability === undefined;
  }

  isNegative() {
    return this.profitability < 0.0;
  }
}
